"use client";

// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useIsEligibleForMobileLoggedOutNavWithCartSignUp } from "@faire/deprecated-retailer-visitor-shared/components/Header/__internal__/useIsEligibleForMobileLoggedOutNavWithCartSignUp";
import { useIsLoggedInRetailer } from "@faire/deprecated-retailer-visitor-shared/lib/isLoggedInRetailer";
import { useIsSSR } from "@faire/web/common/server-side-rendering/isSSR";
import React, { Suspense } from "react";

import { LazyLoggedOutMobileSignUpDrawer } from "./LazyLoggedOutMobileSignUpDrawer";

export const VisitorLoggedOutMobileSignUpDrawer: React.FC = () => {
  const isEligibleForMobileLoggedOutNavWithCartSignUp =
    useIsEligibleForMobileLoggedOutNavWithCartSignUp();
  const isLoggedInRetailer = useIsLoggedInRetailer();
  const isSSR = useIsSSR();

  if (isLoggedInRetailer || isSSR) {
    return null;
  }

  if (isEligibleForMobileLoggedOutNavWithCartSignUp) {
    return (
      <Suspense fallback={null}>
        <LazyLoggedOutMobileSignUpDrawer />
      </Suspense>
    );
  } else {
    return null;
  }
};
